import GCARegistration from "src/components/feature/GCARegistration";

const GCARegistrationPage = () => {
  return (
    <div style={{ marginTop: "-220px" }}>
      <GCARegistration />
    </div>
  );
};

export default GCARegistrationPage;
